import StatusPill from '../common/StatusPill';
import SvgIcon from '@adsk/bim360-matrix-react-svg-icon';
import arrowNext from '../../assets/images/icons/icon-arrow-next.svg';
import {activityLogChangeType} from '../../constants/proptype-validation/activity-proptypes';
import React from 'react';

const ActivityChangeStatusNode = ({change}) => (
  <span className="IssuePreviewActivityContent__status-notes">
    {change.before && <StatusPill className="IssuePreviewActivityContent__activity-pill" status={change.before} />}
    <span className="IssuePreviewActivityContent__status-notes">
      {change.before && (
        <SvgIcon width="15px" height="9px" className="IssuePreviewActivityContent__next-icon">
          {arrowNext}
        </SvgIcon>
      )}
      <StatusPill className="IssuePreviewActivityContent__activity-pill" status={change.after} />
    </span>
  </span>
);

ActivityChangeStatusNode.displayName = 'ActivityChangeStatusNode';

ActivityChangeStatusNode.propTypes = {
  change: activityLogChangeType
};

export default ActivityChangeStatusNode;
